export default __webpack_public_path__ + "static/media/related-post-02.53c6d578.jpg";